import * as React from 'react';

export const DragHandleIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='10'
    height='16'
    viewBox='0 0 10 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    ref={ref}
    {...props}
  >
    <ellipse
      cx='2.07148'
      cy='2'
      rx='1.98213'
      ry='2'
      fill='currentColor'
      fillOpacity='0.2'
    />
    <ellipse
      cx='2.07148'
      cy='8'
      rx='1.98213'
      ry='2'
      fill='currentColor'
      fillOpacity='0.2'
    />
    <ellipse
      cx='2.07148'
      cy='14'
      rx='1.98213'
      ry='2'
      fill='currentColor'
      fillOpacity='0.2'
    />
    <ellipse
      cx='8.01765'
      cy='2'
      rx='1.98213'
      ry='2'
      fill='currentColor'
      fillOpacity='0.2'
    />
    <ellipse
      cx='8.01765'
      cy='8'
      rx='1.98213'
      ry='2'
      fill='currentColor'
      fillOpacity='0.2'
    />
    <ellipse
      cx='8.01765'
      cy='14'
      rx='1.98213'
      ry='2'
      fill='currentColor'
      fillOpacity='0.2'
    />
  </svg>
);
